import { makeVerification } from './makeVerification';

export const verifyCreate = makeVerification('create_project_memberships');
export const verifyEdit = makeVerification('edit_project_memberships');
export const verifyDelete = makeVerification('delete_project_memberships');
